import React from "react";
import { AddedLozenge, AddedLozengeProps } from "../../item/AddedLozenge";
import makeStyles from "@mui/styles/makeStyles";
import { darken, lighten, Theme } from "@mui/material/styles";
import clsx from "clsx";

interface TagChipStyleProps {
  primaryColor?: string;
}

interface TagChipProps extends AddedLozengeProps, TagChipStyleProps {
  primaryColor?: string;
}

const isValidColor = (color?: string) =>
  Boolean(color && color.trim() && /^#?[0-9A-Fa-f]{3,6}$/.test(color));

const useStyles = makeStyles<Theme, TagChipStyleProps>((theme: Theme) => {
  const getColor = ({ primaryColor }: TagChipStyleProps = {}) =>
    isValidColor(primaryColor) ? primaryColor! : theme.palette.primary.main;

  const getBorderColor = (props?: TagChipStyleProps) =>
    darken(getColor(props), 0.2);

  const getBackgroundColor = (props?: TagChipStyleProps) =>
    lighten(getColor(props), 0.4);

  const getTextColor = (props?: TagChipStyleProps) =>
    darken(getColor(props), 0.6);

  return {
    tag: {
      "&.MuiBox-root": {
        margin: 0,
        borderColor: getBorderColor,
      },
      width: "fit-content",
      backgroundColor: getBackgroundColor,
      "& > *": {
        color: getTextColor,
        fontWeight: 500,
      },
    },
  };
});

const TagChip = (props: TagChipProps) => {
  const { primaryColor, text, className, ...other } = props;
  const classes = useStyles({ primaryColor });

  return (
    <AddedLozenge
      text={text}
      className={clsx(className, classes.tag)}
      {...other}
    />
  );
};

export default TagChip;
